import React, { useEffect, useState } from 'react';
import { getGlobalResourceConfig } from '@opm/services';
import LoadingCommon from '@op/components/LoadingCommon';

function useDefaultRequest({ ids, skip = false }: { ids: Array<string>; skip?: boolean }) {
  const [loading, setLoading] = useState(!skip);
  const [config, setConfig] = useState({});

  useEffect(() => {
    if (skip || !ids || ids.length === 0) {
      setLoading(false);
      return;
    }
    getGlobalResourceConfig({ data: { api_list: ids } })
      .then((data: any) => {
        setConfig(data || {});
      }).catch(() => {

      })
      .finally(() => {
        setLoading(false);
      });
  }, [skip]);

  return { loading, config };
}

export default function marketConnect<T>({
  ids,
  dealwith = (data) => data,
  shouldSkipRequest,
}: {
  ids: Array<string>;
  dealwith: (config: any) => T;
  shouldSkipRequest?: () => boolean;
}) {
  return (WrappedComponent: React.ComponentType<T>) => {
    return function Wrapper(props: any) {
      const skip = shouldSkipRequest?.() ?? false;
      const { loading, ...data } = useDefaultRequest({ ids, skip });
      const realProps = skip ? dealwith({ config: {} }) : dealwith(data);

      return loading ? (
        <LoadingCommon isFullPage status="loading" />
      ) : (
        <WrappedComponent {...props} {...realProps} />
      );
    };
  };
}
